import block from "bem-cn";
import { useRef } from "react";
import { routes } from "../../routes";
import Button from "../Button/Button";
import InputField from "../InputField/InputField";
import "./BookingForm.scss";

const b = block("BookingForm");

const BookingForm = () => {
  const ufInput = useRef<HTMLInputElement>(null);

  const onHandleButtonClick = () => {
    ufInput.current?.click();
  }

  return (
    <form className={b()}>
      <div className={b("wrapper")}>
        <h2 className={b("caption")}>Бронировать</h2>
        <ul className={b("inputs")}>
          <li className={b("email")}>
            <InputField type="text" placeholder="Срок бронирования" />
          </li>
          <li className={b("password")}>
            <InputField type="text" placeholder="Проект, вакансия" />
          </li>
          <li className={b("upload-files-wrapper")}>
            <label className={b('upload-files')}>
              <Button addOnClick={onHandleButtonClick} width100 height100 paddingTB0 text="Загрузить файлы" />
              <input ref={ufInput} className={b('upload-files-input').state({ 'visually-hidden': true })} type='file' />
            </label>
          </li>
        </ul>

        <Button link={routes.bookingCompleted} width100 text="Отправить" />
      </div>
    </form>
  );
};

export default BookingForm;
